export default {
  title: {
    id: 'product_highlighted_picker_title',
    defaultMessage: 'Our goodest finds',
  },
}
